export const CLEAR_AD = 'Ads/CLEAR_AD';
export const EMPTY_ADS = 'Ads/EMPTY_ADS';
export const SET_AD = 'Ads/SET_AD';
export const SET_ADS = 'Ads/SET_ADS';

export const FETCH_ADS = 'Ads/FETCH_ADS';
export const FETCH_ADS_SUCCESS = 'Ads/FETCH_ADS_SUCCESS';
export const FETCH_ADS_FAILURE = 'Ads/FETCH_ADS_FAILURE';

export const SAVE_AD = 'Ads/SAVE_AD';
export const SAVE_AD_SUCCESS = 'Ads/SAVE_AD_SUCCESS';
export const SAVE_AD_FAILURE = 'Ads/SAVE_AD_FAILURE';



// WEBPACK FOOTER //
// ./src/containers/AdsPage/store/constants.js